import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Checkbox, RadioButton, RadioButtonGroup, SelectInput, withIgnoreUnderScore } from "~/core";
import { constants, model, service } from "../../data";
import { adminData } from "~/admin/data";
import { messages } from "./../../../i18n-messages";
import { TemplateManagerRows } from "./template-manager-rows";
import "./template-manager-grid.css";

export class TemplateManagerGrid extends Component {
    static propTypes = {
        columns: PropTypes.array,
        currentTab: PropTypes.number,
        data: PropTypes.array,
        fileMetadata: PropTypes.object,
        formatMessage: PropTypes.func,
        importAttributes: PropTypes.array,
        sampleAttributes: PropTypes.array,
        updateImportAttributes: PropTypes.func,
        updateImportTemplateList: PropTypes.func,
        hideTopBar: PropTypes.bool,
        className: PropTypes.string,
    };

    static SAMPLE_ATTRIBUTE_GUID = "sampleAttributeGuid";
    static SAMPLE_ATTRIBUTE_NAME = "sampleAttributeName";

    constructor(props) {
        super(props);
        this.state = {
            sampleAttributes:
                this.prepareSelectableOptions(props.sampleAttributes, {
                    guid: TemplateManagerGrid.SAMPLE_ATTRIBUTE_GUID,
                    label: TemplateManagerGrid.SAMPLE_ATTRIBUTE_NAME,
                }) || [],
            selectedSampleAttributes: props.importAttributes || [],
            showMappedAttributes: false,
            isMonitorType: false,
            headerRow: Boolean(props.fileMetadata[model.PROPS_HEADER_ROW]),
            matchHeaderName: Boolean(props.fileMetadata[model.PROPS_MATCH_HEADER_NAME]),
        };
        this.NewSelectInput = withIgnoreUnderScore(SelectInput);
        this.isShapeFile = true;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data) ||
            nextProps.sampleAttributes !== this.props.sampleAttributes ||
            nextProps.importAttributes !== this.props.importAttributes ||
            nextState.sampleAttributes !== this.state.sampleAttributes ||
            nextState.selectedSampleAttributes !== this.state.selectedSampleAttributes ||
            nextState.showMappedAttributes !== this.state.showMappedAttributes ||
            nextState.headerRow !== this.state.headerRow ||
            nextState.matchHeaderName !== this.state.matchHeaderName
        );
    }

    componentDidUpdate(prevProps) {
        this.initializeSampleAttributes(prevProps);

        if (!_.isEqual(this.props.importAttributes, prevProps.importAttributes)) {
            this.setState({
                selectedSampleAttributes: this.props.importAttributes,
            });
        }
        // Compare the fields read below, not `fileMetadata` itself - the parent hands
        // down a fresh reference on every render, which would setState every time.
        const { fileMetadata } = this.props;
        const prevFileMetadata = prevProps.fileMetadata;
        const fileMetadataChanged =
            fileMetadata.fileTypes !== prevFileMetadata.fileTypes ||
            fileMetadata[model.PROPS_HEADER_ROW] !== prevFileMetadata[model.PROPS_HEADER_ROW] ||
            fileMetadata[model.PROPS_MATCH_HEADER_NAME] !==
                prevFileMetadata[model.PROPS_MATCH_HEADER_NAME];
        if (fileMetadataChanged) {
            if (this.isShapeFileFormat(fileMetadata.fileTypes)) {
                this.isShapeFile = false;
            }
            this.setState({
                headerRow: Boolean(fileMetadata[model.PROPS_HEADER_ROW]),
                matchHeaderName: Boolean(fileMetadata[model.PROPS_MATCH_HEADER_NAME]),
            });
        }
    }

    prepareSelectableOptions = (options, { guid, label }) =>
        _.reduce(
            options,
            (result, option) => {
                result.push({ value: option[guid], label: option[label] });
                return result;
            },
            []
        );

    initializeSampleAttributes = (prevProps) => {
        if (this.props.sampleAttributes !== prevProps.sampleAttributes) {
            this.setState({
                [constants.SAMPLE_ATTRIBUTES]: this.prepareSelectableOptions(
                    this.props.sampleAttributes,
                    {
                        guid: TemplateManagerGrid.SAMPLE_ATTRIBUTE_GUID,
                        label: TemplateManagerGrid.SAMPLE_ATTRIBUTE_NAME,
                    }
                ),
            });
        }
    };

    onSampleAttributeChange = (value, importFileColumnName, columnOrderInFile) => {
        this.props.updateImportAttributes({
            importTemplateListIndex: this.props.currentTab,
            value: {
                importAttributeGuid: value || "",
                columnNameInFile: importFileColumnName,
                columnOrderInFile,
                isShapeFile: this.isShapeFile,
            },
        });
    };

    isShapeFileFormat(fileTypes) {
        const textFileFormats = [".txt", ".csv"];
        return textFileFormats.indexOf(fileTypes) > -1;
    }

    getSelectableOptions = (value) => {
        const selectedSampleAttributes = this.props.importAttributes;
        const sampleAttributes = this.state.sampleAttributes.slice();
        const propToBeCompared = this.isShapeFile
            ? model.PROPS_COLUMN_NAME_IN_FILE
            : model.PROPS_COLUMN_ORDER_IN_FILE;
        _.remove(sampleAttributes, (attr) => {
            for (let key in selectedSampleAttributes) {
                if (
                    value !== selectedSampleAttributes[key][propToBeCompared] &&
                    attr.value === selectedSampleAttributes[key].importAttributeGuid
                ) {
                    return true;
                }
            }
            return false;
        });
        return sampleAttributes;
    };

    getImportAttributeValue = (importFileColumnName, orderInFile) => {
        const importAttribute = this.props.importAttributes.find((attr) => {
            return this.isShapeFile
                ? attr.columnNameInFile === importFileColumnName
                : attr.columnOrderInFile === orderInFile;
        });
        return importAttribute ? importAttribute.importAttributeGuid : null;
    };

    onRadioButtonChange = (value) => {
        this.setState({
            showMappedAttributes: value === "showMapped",
        });
    };

    renderAttributes = () => {
        const columns = this.getFilteredColumns(this.props.columns);
        const { NewSelectInput } = this;
        return (
            columns &&
            columns.map(({ importFileColumnName, orderInFile }, index) => {
                const displayCount = index + 1;
                return (
                    <div
                        className="import-attribute-cont"
                        key={`${importFileColumnName}-${displayCount}`}
                    >
                        <span className="counter-cont">{displayCount}</span>
                        <NewSelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            value={this.getImportAttributeValue(importFileColumnName, orderInFile)}
                            options={this.getSelectableOptions(
                                this.isShapeFile ? importFileColumnName : orderInFile
                            )}
                            onChange={(value) =>
                                this.onSampleAttributeChange(
                                    value,
                                    importFileColumnName,
                                    orderInFile
                                )
                            }
                            placeholderText={""}
                        />
                    </div>
                );
            })
        );
    };

    getFilteredColumns = (data) => {
        const { selectedSampleAttributes, showMappedAttributes } = this.state;
        if (showMappedAttributes) {
            return (
                data &&
                data.filter(({ importFileColumnName }) => {
                    for (let key in selectedSampleAttributes) {
                        if (
                            selectedSampleAttributes[key].columnNameInFile === importFileColumnName
                        ) {
                            return true;
                        }
                    }
                    return false;
                })
            );
        } else {
            return data;
        }
    };

    isHeaderRowDisabled = () => {
        const { fileMetadata } = this.props;
        return service.isTextFileFormat(fileMetadata.fileTypes);
    };

    onChangeHeaderRow = (event, value) => {
        this.setState(
            {
                headerRow: value,
            },
            () =>
                this.props.updateImportTemplateList({
                    key: model.PROPS_HEADER_ROW,
                    value: value ? 1 : 0,
                })
        );
    };

    isMatchHeaderNameDisabled = () => {
        const { fileMetadata } = this.props;
        return service.isTextFileFormat(fileMetadata.fileTypes);
    };

    onChangeMatchHeaderName = (event, value) => {
        this.setState(
            {
                matchHeaderName: value,
            },
            () =>
                this.props.updateImportTemplateList({
                    key: model.PROPS_MATCH_HEADER_NAME,
                    value: value ? 1 : 0,
                })
        );
    };

    render() {
        const { formatMessage, data, hideTopBar, className = "form-section" } = this.props;
        const { showMappedAttributes } = this.state;
        return (
            <div className={`template-manager-grid ${className}`}>
                {data && data.length > 0 && !hideTopBar && (
                    <div className="grid-header">
                        <Checkbox
                            label={formatMessage(messages.headerRow)}
                            disabled={this.isHeaderRowDisabled()}
                            value={this.state.headerRow}
                            onChange={this.onChangeHeaderRow}
                            testId="template-manager-grid-header-row-checkbox"
                        />
                        <Checkbox
                            label={formatMessage(messages.matchHeaderName)}
                            disabled={this.isMatchHeaderNameDisabled()}
                            visible={this.state.headerRow}
                            value={this.state.matchHeaderName}
                            onChange={this.onChangeMatchHeaderName}
                            testId="template-manager-grid-match-header-name-checkbox"
                        />
                        <RadioButtonGroup
                            className={"grid-header-radio-group"}
                            selectedValue={showMappedAttributes ? "showMapped" : "showAll"}
                            afterOnChange={this.onRadioButtonChange}
                        >
                            <RadioButton
                                tabIndex={0}
                                value={"showAll"}
                                label={formatMessage(messages.showAll)}
                                testId="template-manager-grid-show-all-radio"
                            />
                            <RadioButton
                                tabIndex={0}
                                value={"showMapped"}
                                label={formatMessage(messages.showMapped)}
                                testId="template-manager-grid-show-mapped-radio"
                            />
                        </RadioButtonGroup>
                    </div>
                )}
                <div className="template-manager-grid-container">
                    <div className="template-manager-grid-table">
                        <div className="template-manager-attributes">{this.renderAttributes()}</div>
                        <div className="template-manager-rows">
                            <TemplateManagerRows
                                data={this.props.data}
                                headerRow={this.state.headerRow}
                                selectedSampleAttributes={this.state.selectedSampleAttributes}
                                showMappedAttributes={this.state.showMappedAttributes}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
